export default __webpack_public_path__ + "static/media/gadget.cc551298.png";